import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { GIANT_CONFIG } from '../services/config-service';



@NgModule()
export class GiantModule
{
    constructor(@Optional() @SkipSelf() parentModule: GiantModule)
    {
        if ( parentModule )
        {
            throw new Error('GiantModule is already loaded. Import it in the AppModule only!');
        }
    }

    static forRoot(config): ModuleWithProviders<GiantModule>
    {
        return {
            ngModule : GiantModule,
            providers: [
                {
                    provide : GIANT_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
